// Core
import { ROUTING_LOGIN } from "@constants/routing";
import { UserContext } from "@context/User/UserContext";
import React, { useContext, useEffect } from "react";
// Hooks
import { useNavigate } from "react-router-dom";
// Constants

export type AuthGuardElement = HTMLDivElement;

export type AuthGuardDefaultProps = {};

export const AuthGuard = React.forwardRef<
  AuthGuardElement,
  React.PropsWithChildren<AuthGuardDefaultProps>
>(({ children }, ref) => {
  const { currentUser } = useContext(UserContext);
  const navigate = useNavigate();
  const granted = currentUser.user_id !== -1;

  useEffect(() => {
    if (!granted) {
      navigate(ROUTING_LOGIN);
    }
  }, [granted, navigate]);

  return <>{granted && children}</>;
});

export default AuthGuard;
